import axios from "axios";
import Config from "../config/Config";
import UserMessageInterface from "../interfaces/UserMessageInterface";
import authHeader from "./auth-header";

const API_BUSINESS_URL = Config.BASE_URL_API_BUSINESS;
const API_URL = Config.BASE_URL_API;
const API_CHAT = Config.BASE_URL_API_CHAT;
const API_USER = Config.BASE_URL_API_USER;
const API_PUBLIC_URL = Config.BASE_URL_API_PUBLIC;

const functionsUser = {
	getProfileAddress(userID: string){
		return axios.get(API_BUSINESS_URL + `/api/user/${userID}/profile/address`, { headers: authHeader() });
	},
	setProfileAddress(userID: string, address: any){
		return axios.post(API_BUSINESS_URL + `/api/user/${userID}/profile/address`, {address}, { headers: authHeader() })
	},
	getOrder(orderID: string){
		return axios.get(API_URL + `/order/${orderID}`, { headers: authHeader() });
	},
	getOrderMessages(orderID: string){
		return axios.get(API_CHAT + `/order/${orderID}/messages`, { 'headers': { Authorization: Config.HEADER_AUTHORIZATION } });
	},
	sendOrderMessage(orderID: string, newMessage: UserMessageInterface){
		return axios.post(API_CHAT + `/order/${orderID}/messages/store`, newMessage, { headers: authHeader() });
	},
	getOrderDeliveryManLocation(deliveryManID: string){
		return axios.get(API_USER + `/user/locationHistory/${deliveryManID}/last/1`, { headers: { Authorization: Config.HEADER_AUTHORIZATION } });
	},
	getApp(appID: string){
		return axios.get(API_BUSINESS_URL + `/api/app/${appID}`, { headers: authHeader() });
	},
	getUserApp(){
		return axios.get(API_BUSINESS_URL + `/api/user/app`, { headers: authHeader() });
	},
	getUserPrepaidBalance(){
		return axios.get(API_PUBLIC_URL + `/user/balance`, { headers: authHeader() });
	}
};

export default functionsUser;